function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.786 8.41334C16.2763 7.39085 15.2202 6.68848 14.0001 6.68848C12.7799 6.68848 11.7239 7.39085 11.2141 8.41334",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.77368 7.69971C9.48897 5.7679 11.2311 4.19971 14 4.19971C16.7689 4.19971 18.511 5.7679 19.2263 7.69971",
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8001 2.7998L18.9001 7.69981",
  stroke: "white",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.511 13.2996C11.511 11.5814 10.1181 10.1885 8.39993 10.1885C6.68171 10.1885 5.28882 11.5814 5.28882 13.2996",
  stroke: "white",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14 13.2997C14 10.5506 12.1334 7.69971 8.40005 7.69971C4.66672 7.69971 2.80005 10.5506 2.80005 13.2997",
  stroke: "white",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.711 13.2996C22.711 11.5814 21.3181 10.1885 19.5999 10.1885C17.8817 10.1885 16.4888 11.5814 16.4888 13.2996",
  stroke: "white",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2 13.2997C25.2 10.5506 23.3333 7.69971 19.6 7.69971C15.8667 7.69971 14 10.5506 14 13.2997",
  stroke: "white",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40005 23.0998C4.95686 21.1892 2.80005 17.5166 2.80005 13.2998H25.2C25.2 17.5166 23.0432 21.1892 19.6 23.0998",
  stroke: "white",
  strokeWidth: 2
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 8.40015,
  y: 23.0996,
  width: 11.2,
  height: 2.8,
  stroke: "white",
  strokeWidth: 2
});

var SvgPasta = function SvgPasta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPasta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pasta.e6480be2.svg";
export { ForwardRef as ReactComponent };